<template>
  <el-card class="m-b">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">订单基本信息</span>
      <span class="info-source">信息来源：{{ sysName || "系统新建" }}</span>
    </div>
    <div class="order-content-detail">
      <el-form
        :model="baseInfo"
        label-position="right"
        label-width="150px"
        :gutter="20"
        disabled
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单名称：" prop="orderName">
              <el-input v-model="baseInfo.orderName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号：" prop="orderCode">
              <el-input v-model="baseInfo.orderCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="(baseInfo.projectId || isNotInJcSys) && system === 'purchaser'">
          <el-col :span="12">
            <el-form-item label="履约项目编号：" prop="projectCode">
              <el-input v-model="baseInfo.projectCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="履约项目名称：" prop="projectName" class="form-items__btn">
              <el-input v-model="baseInfo.projectName"></el-input>
              <span v-if="!isNotInJcSys" class="detail-btn" @click="skipDetailPage(1)">详情</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="baseInfo.inquireId && system === 'purchaser'">
          <el-col :span="12">
            <el-form-item label="询单编号：" prop="inquireCode">
              <el-input v-model="baseInfo.inquireCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="询单名称：" prop="inquireName" class="form-items__btn">
              <el-input v-model="baseInfo.inquireName"></el-input>
              <span class="detail-btn" @click="skipDetailPage(2)">详情</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单类型：" prop="purchaseType">
              <el-radio
                v-if="baseInfo.purchaseType==1"
                v-model="baseInfo.purchaseType"
                label="1"
              >
                小额零星采购
              </el-radio>
              <el-radio
                v-if="baseInfo.purchaseType==2"
                v-model="baseInfo.purchaseType"
                label="2"
              >
                集采询单
              </el-radio>
              <!-- <el-radio-group v-model="baseInfo.purchaseType">
                <el-radio
                  v-for="(value, id) in enums.inquireType"
                  :key="id"
                  :label="id">
                  {{value}}
                </el-radio>
              </el-radio-group> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单种类：" prop="orderType">
              <el-radio-group v-model="baseInfo.orderType">
                <el-radio
                  v-for="(value, id) in enums.orderCategory"
                  :key="id"
                  :label="id">
                  {{value}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单状态：" prop="status">
              <span :class="[`main-status-${baseInfo.status}`]">{{getValue('mainOrderStatus', baseInfo.status)}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" v-if="baseInfo.payTypeList">
            <el-form-item label="付款方式占比：">
              <template v-if="baseInfo.payTypeList && baseInfo.payTypeList.length > 1">
                <div class="percent-box">
                  <div class="percent-items" v-for="item in baseInfo.payTypeList" :key="item.id">
                    <p>{{item.name}}(%)</p>
                    <p>{{item.value}}%</p>
                  </div>
                </div>
              </template>
              <template v-else>
                <span>{{baseInfo.payTypeList && baseInfo.payTypeList[0].name}}</span>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" v-if="baseInfo.projectUser">
            <el-form-item label="项目组成员：" prop="projectUser">
              <member-select
                :disabled="true"
                :authType="40"
                v-model="baseInfo.projectUser"
              ></member-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采购单位：" prop="purchaseName">
              <el-input v-model="baseInfo.purchaseName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单联系人：" prop="contactName">
              <el-input v-model="baseInfo.contactName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contactPhone" label="订单人联系电话：">
              <el-input v-model="baseInfo.contactPhone">
                <el-select
                  size="mini"
                  style="width:100px"
                  v-model="baseInfo.contactPhonePrefix"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <!-- <el-option label="中国+86" value="+86"></el-option> -->
                  <el-option
                    v-for="(item, index) in enums.phoneAreaCodeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >{{ item.label }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="币种：" prop="currencyCH">
              <el-input v-model="baseInfo.currencyCH"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="Number(baseInfo.status) >= 1006">
            <el-form-item label="电子订单：" prop="certFileId">
              <span class="form-items__blue" @click="showOrderDialog">{{baseInfo.certFileId ? baseInfo.fileList && baseInfo.fileList.length && baseInfo.fileList[0].name : '电子订单.pdf'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="供应商编号：" prop="supplierCorp">
              <el-input v-model="baseInfo.supplierCorp"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称：" prop="supplierName">
              <el-input v-model="baseInfo.supplierName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="供应商联系人：" prop="supplierContactName">
              <el-input v-model="baseInfo.supplierContactName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商联系人电话：" prop="supplierContactPhone">
              <el-input v-model="baseInfo.supplierContactPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="附件：" prop="fileId">
              <zsFileDownload :fileId="baseInfo.fileId"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="baseInfo.remark" type="textarea" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>
<script>
import { enums, getValue } from '@/lib/enum'
import memberSelect from '@/components/business/memberSelect'
import electronicCertDialog from '@/components/dialog/electronicCertDialog'
import zsFileDownload from '@/components/zsFileDownload'
import { mapActions } from 'vuex'
export default {
  components: {
    memberSelect,
    zsFileDownload
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    },
    secondInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      enums,
      getValue,
      system: this.$store.state.system, // 当前登录的是哪个系统
      baseInfo: {}, // 第一步基本信息
      sysName: ''
    }
  },
  computed: {
    // 是否集采-不使用集采系统内履约的项目
    isNotInJcSys() {
      return +this.baseInfo.purchaseType === 2 && this.baseInfo.isUseXiTongNeiProject === 0
    }
  },
  watch: {
    secondInfo(val) {
      this.baseInfo = {
        ...this.baseInfo,
        ...val
      }
    },
    basicInfo(val) {
      this.baseInfo = val
      this.getSysName()
    }
  },
  created() {
    this.handleIsFlower()
  },
  // activated() {
  //   if (this.$route.params.isReLoad) {
  //     this.handleIsFlower()
  //   }
  // },
  methods: {
    ...mapActions([
      'queryApiConfigManagerBySysNo',
      'judgeIsFlowUser'
    ]),
    getSysName() {
      if (this.baseInfo.duiJieXiTongNo) {
        this.queryApiConfigManagerBySysNo({ sysNo: this.baseInfo.duiJieXiTongNo }).then(response => {
          this.sysName = response.sysName
        })
      }
    },
    // 显示电子凭证
    showOrderDialog() {
      this.$zl.dialog.openFull(electronicCertDialog, {
        orderId: this.baseInfo.id,
        isSign: this.system === 'purchaser' ? this.baseInfo.purchaseSign : this.baseInfo.supplierSign, // 是否已经签章过
        system: this.system,
        baseInfo: this.baseInfo
      }).then((res) => {
        if (res) {
          this.$zl.message.success('签章成功！')
          this.$emit('success')
        }
      })
    },
    // 跳至相应的详情接口
    skipDetailPage(type) {
      this.$router.push({
        name: type === 1 ? 'PurchaserContractCheck' : 'InquiryBillCheck',
        query: {
          id: type === 1 ? this.baseInfo.projectId : this.baseInfo.inquireId,
          isOrder: type === 1, // 跳至合同详情页需要
          isFlower: type === 1 ? this.isFlower : '' // 是否是审批人
        }
        // params: {
        //   isReLoad: true
        // }
      })
    },
    // 判断当前登录用户是否订单审批人，如果是则该用户可以看到跳转到合同详情页的全部内容
    handleIsFlower() {
      this.judgeIsFlowUser({
        unionId: this.baseInfo.id
      }).then(res => {
        this.isFlower = res
      })
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/order.scss';
.info-source {
  font-size: 14px;
  background-color: #f9e0a3;
  height: 22px;
  line-height: 22px;
  border-radius: 8px;
  margin-left: 10px;
  padding: 0 10px;
  color: #947441;
}
</style>

